import React from 'react';
import './main.css';
import { Typography, Grid } from "@material-ui/core";

import AppearingElement from "../Helper/AppearingElement";

function Half(props) {
    return (
        <section className="half-section">
            <Grid container>
                <Grid item xs={12} sm={12} md={6}>
                    <div className="half-section__bar-app">
                        <Typography className="half-section__bar__header-app" variant="h4">
                            <AppearingElement variant="zoom-down">
                                With a More User-Centric Solution You Will:
                            </AppearingElement>
                        </Typography>
                        <ul className="half-section__bar__content-app">
                            <li className="ziplyne-list__zip"><Typography className="ziplyne-list__item"
                                variant="subtitle1">Increase Adoption and
                                Engagement</Typography></li>
                            <li className="ziplyne-list__zip"><Typography className="ziplyne-list__item"
                                variant="subtitle1">Improve Onboarding &
                                Training Processes</Typography></li>
                            <li className="ziplyne-list__zip"><Typography className="ziplyne-list__item"
                                variant="subtitle1">Decrease Support/Operation
                                Costs (including # of tickets)</Typography></li>
                            <li className="ziplyne-list__zip"><Typography className="ziplyne-list__item"
                                variant="subtitle1">Reduce Need for Refresher
                                Training Courses and Support Materials</Typography></li>
                            <li className="ziplyne-list__zip"><Typography className="ziplyne-list__item"
                                variant="subtitle1">Reduce Software
                                Friction</Typography></li>
                            <li className="ziplyne-list__zip"><Typography className="ziplyne-list__item"
                                variant="subtitle1">Increase Employee
                                Productivity</Typography></li>
                        </ul>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <img alt="ZL ontop of Workday" src={props.screenshot} className="half-section__media-app" />
                </Grid>
            </Grid>


        </section>
    )
}

export default Half